import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import 'rxjs/add/operator/do';

import { Store } from '@ngrx/store';
import * as fromApp from '../../shared/store/app.reducer';
import { AppConfig } from '../../config/app-config';
import { CookieService } from 'ngx-cookie-service';
import { Logout } from '../../auth/store/actions/auth.actions';

@Injectable()
export class CookieSessionInterceptor implements HttpInterceptor {
    constructor(
        private injector: Injector,
        private store: Store<fromApp.AppState>,
        private cookieSerivce: CookieService
    ) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.indexOf('apmailinglmsrouter') > -1 || request.url.indexOf('lapreports') > -1) {
            console.log('1. Intercepting:', request.url);
            // const oauthCookie = this.cookieSerivce.get(AppConfig.settings.apiServer.authDetails.capoauth) || null;

            // if (!oauthCookie) {
            //     this.store.dispatch(new Logout());
            // }
        }
        return next.handle(request);
    }
}
